module.exports = __webpack_public_path__ + "img/facturas.4c84dd45.jpg";